import { apiCall } from '../../utils/restclient'
import {
  EDIT_PREFERENCES_SETTINGS,
  EDIT_PREFERENCES_SETTINGS_ERROR,
  EDIT_PREFERENCES_SETTINGS_SUCCESS,
  EDIT_PROVIDER_PASSWORD,
  EDIT_PROVIDER_PASSWORD_ERROR,
  EDIT_PROVIDER_PASSWORD_SUCCESS,
  EDIT_PROVIDER_PROFILE_IMAGE,
  EDIT_PROVIDER_PROFILE_IMAGE_ERROR,
  EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS,
  EDIT_PROVIDER_PROFILE_INFO,
  EDIT_PROVIDER_PROFILE_INFO_ERROR,
  EDIT_PROVIDER_PROFILE_INFO_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_ERROR,
  GET_SERVICE_TYPES_SUCCESS,
} from './AccountSettingsConstants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const editProviderPassword = ({ CurrentPassword, NewPassword, tabId }) => {
  const endpoint = `api/v1/profile/password`
  const action = {
    type: EDIT_PROVIDER_PASSWORD,
  }
  try {
    const editedBody = {
      CurrentPassword,
      NewPassword,
    }
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(editedBody), {
      success: EDIT_PROVIDER_PASSWORD_SUCCESS,
      error: EDIT_PROVIDER_PASSWORD_ERROR,
      extraData: { tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const editProviderProfileInfo = (editedBody, type, tabId) => {
  const endpoint = `api/v1/profile`
  const action = {
    type: EDIT_PROVIDER_PROFILE_INFO,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(editedBody), {
      success: EDIT_PROVIDER_PROFILE_INFO_SUCCESS,
      error: EDIT_PROVIDER_PROFILE_INFO_ERROR,
      extraData: { type, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const editProviderProfileImage = (editedBody) => {
  const endpoint = `api/v1/profile/image`
  const action = {
    type: EDIT_PROVIDER_PROFILE_IMAGE,
  }
  try {
    apiCall(
      endpoint,
      'PUT',
      null,
      editedBody,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS,
        error: EDIT_PROVIDER_PROFILE_IMAGE_ERROR,
      },
      null,
      {},
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

export const getServiceTypes = () => {
  const endpoint = `api/v1/servicetypes`
  const action = {
    type: GET_SERVICE_TYPES,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_SERVICE_TYPES_SUCCESS,
      error: GET_SERVICE_TYPES_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const editPreferencesSettings = (newPreferencesBody) => {
  const endpoint = `api/v1/profile/settings`
  const action = {
    type: EDIT_PREFERENCES_SETTINGS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify(newPreferencesBody), {
      success: EDIT_PREFERENCES_SETTINGS_SUCCESS,
      error: EDIT_PREFERENCES_SETTINGS_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
